var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('math-field',{class:'eq-editor ' +_vm.size+(_vm.state == null ? '' : (_vm.state == true ? ' valid' : ' invalid')),attrs:{"id":_vm.id,"virtual-keyboard-mode":"manual","disabled":_vm.disabled},on:{"input":_vm.inputChanged}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }